import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PDFIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";
import {TableScrollButton} from "@pg-rp/comparison-table";

import {useComparisonToolContext} from "../contexts/comparison_tool_context";
import {IAnalyticEvents} from "../interfaces/IAnalyticEvents";

interface IProps extends IAnalyticEvents {
    total: number;
    hasActiveProperties: boolean;
}

export const ComparisonToolViewHeader = (props: IProps) => {
    const {total, hasActiveProperties} = props;
    const {isMobile} = useUserDevice();
    const {print, setAskForAllModalOpened} = useComparisonToolContext();

    const showNoDataHeader = !props.total;

    return (
        <div className={headerStyle}>
            <div className={headerTitleStyle}>
                <div className={titleWrapStyle}>
                    <Text as="h1" variant="headline_2" className={titleStyle}>
                        {showNoDataHeader ? "Nie masz żadnych ofert do porównania" : "Porównaj oferty"}
                    </Text>
                </div>
                {isMobile && !showNoDataHeader && (
                    <div className={mobileNavigation}>
                        <TableScrollButton left onClick={props.onLeftArrowClick} />
                        <TableScrollButton onClick={props.onRightArrowClick} />
                    </div>
                )}
            </div>
            {total > 0 && (
                <div className={headerActionsStyle}>
                    {hasActiveProperties && (
                        <Button
                            variant="filled_primary"
                            size="x-small"
                            onClick={() => {
                                setAskForAllModalOpened(true);
                            }}
                        >
                            Zapytaj o wszystkie
                        </Button>
                    )}
                    <Button iconLeft={PDFIcon} className={downloadButtonStyle} onClick={print} variant="outlined_secondary" size="x-small">
                        Pobierz
                    </Button>
                </div>
            )}
        </div>
    );
};

const headerStyle = css({
    marginBottom: 3,
    display: "flex",
    flexDirection: "column",
    md: {
        marginBottom: 6
    },
    "@media print": {
        marginBottom: "3rem",
        display: "inline"
    }
});

const headerTitleStyle = css({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 3
});

const headerActionsStyle = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});

const titleWrapStyle = css({
    display: "flex",
    flexDirection: "column"
});

const titleStyle = css({
    marginBottom: 0.5
});

const mobileNavigation = css({
    display: "flex",
    justifyContent: "space-between",
    columnGap: "2.4rem",
    alignItems: "flex-start"
});

const downloadButtonStyle = css({
    "@media print": {
        display: "none !important"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PDFIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";
import {TableScrollButton} from "@pg-rp/comparison-table";

import {useComparisonToolContext} from "../contexts/comparison_tool_context";
import {IAnalyticEvents} from "../interfaces/IAnalyticEvents";

interface IProps extends IAnalyticEvents {
    total: number;
    hasActiveProperties: boolean;
}

export const ComparisonToolViewHeader = (props: IProps) => {
    const {total, hasActiveProperties} = props;
    const {isMobile} = useUserDevice();
    const {print, setAskForAllModalOpened} = useComparisonToolContext();

    const showNoDataHeader = !props.total;

    return (
        <div className={headerStyle}>
            <div className={headerTitleStyle}>
                <div className={titleWrapStyle}>
                    <Text as="h1" variant="headline_2" className={titleStyle}>
                        {showNoDataHeader ? "Nie masz żadnych ofert do porównania" : "Porównaj oferty"}
                    </Text>
                </div>
                {isMobile && !showNoDataHeader && (
                    <div className={mobileNavigation}>
                        <TableScrollButton left onClick={props.onLeftArrowClick} />
                        <TableScrollButton onClick={props.onRightArrowClick} />
                    </div>
                )}
            </div>
            {total > 0 && (
                <div className={headerActionsStyle}>
                    {hasActiveProperties && (
                        <Button
                            variant="filled_primary"
                            size="x-small"
                            onClick={() => {
                                setAskForAllModalOpened(true);
                            }}
                        >
                            Zapytaj o wszystkie
                        </Button>
                    )}
                    <Button iconLeft={PDFIcon} className={downloadButtonStyle} onClick={print} variant="outlined_secondary" size="x-small">
                        Pobierz
                    </Button>
                </div>
            )}
        </div>
    );
};

const headerStyle = css({
    marginBottom: 3,
    display: "flex",
    flexDirection: "column",
    md: {
        marginBottom: 6
    },
    "@media print": {
        marginBottom: "3rem",
        display: "inline"
    }
});

const headerTitleStyle = css({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 3
});

const headerActionsStyle = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});

const titleWrapStyle = css({
    display: "flex",
    flexDirection: "column"
});

const titleStyle = css({
    marginBottom: 0.5
});

const mobileNavigation = css({
    display: "flex",
    justifyContent: "space-between",
    columnGap: "2.4rem",
    alignItems: "flex-start"
});

const downloadButtonStyle = css({
    "@media print": {
        display: "none !important"
    }
});
